var _path, _line, _line2, _line3, _line4, _path2, _path3, _path4, _line5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStarsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 28,
    viewBox: "0 0 31 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2227 7.46296L21.2412 9.75926L22.9634 14.3519L26.4078 11.4815H31.0004L29.2782 6.88889L31.0004 2.87037H25.8338L22.3893 0L21.2412 4.59259L17.2227 7.46296Z",
    fill: "url(#paint0_linear)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12.8054,
    y1: 7.35684,
    x2: 3.62026,
    y2: 10.8013,
    stroke: "#FF3269"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 18.5457,
    y1: 14.2455,
    x2: 9.36049,
    y2: 17.69,
    stroke: "#FF3269"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 5.92691,
    y1: 18.8344,
    x2: 0.186166,
    y2: 21.1307,
    stroke: "#FF3269"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 15.0839,
    y1: 10.8073,
    x2: 11.6395,
    y2: 11.9555,
    stroke: "#FF3269"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.73297 2.94811C3.99523 3.06467 4.10575 3.37759 3.97488 3.63301L3.33908 4.87392C3.21316 5.11968 3.31031 5.42098 3.55607 5.54691V5.54691C3.80184 5.67283 4.10314 5.57568 4.22906 5.32991L4.91532 3.99054C5.03635 3.75433 5.32084 3.65384 5.56338 3.76163L6.85407 4.33528C7.10641 4.44743 7.40189 4.33379 7.51405 4.08145V4.08145C7.6262 3.8291 7.51255 3.53362 7.26021 3.42147L6.07063 2.89276C5.80837 2.7762 5.69784 2.46328 5.82871 2.20786L6.58289 0.735918C6.70881 0.490156 6.61166 0.188849 6.3659 0.0629279V0.0629279C6.12014 -0.0629927 5.81883 0.0341575 5.69291 0.279919L4.88828 1.85033C4.76725 2.08654 4.48275 2.18703 4.24022 2.07924L3.00691 1.53109C2.75457 1.41894 2.45908 1.53258 2.34693 1.78493V1.78493C2.23478 2.03727 2.34842 2.33275 2.60076 2.4449L3.73297 2.94811Z",
    fill: "#FF3269"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.4732 24.7635C9.73546 24.8801 9.84599 25.193 9.71512 25.4484L9.07932 26.6893C8.9534 26.9351 9.05055 27.2364 9.29631 27.3623V27.3623C9.54207 27.4883 9.84338 27.3911 9.9693 27.1453L10.6556 25.806C10.7766 25.5698 11.0611 25.4693 11.3036 25.5771L12.5943 26.1507C12.8466 26.2629 13.1421 26.1492 13.2543 25.8969V25.8969C13.3664 25.6445 13.2528 25.3491 13.0004 25.2369L11.8109 24.7082C11.5486 24.5916 11.4381 24.2787 11.5689 24.0233L12.3231 22.5513C12.449 22.3056 12.3519 22.0043 12.1061 21.8784V21.8784C11.8604 21.7524 11.5591 21.8496 11.4331 22.0953L10.6285 23.6658C10.5075 23.902 10.223 24.0025 9.98045 23.8947L8.74714 23.3465C8.4948 23.2344 8.19932 23.348 8.08717 23.6004V23.6004C7.97501 23.8527 8.08866 24.1482 8.341 24.2603L9.4732 24.7635Z",
    fill: "#FF3269"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0533 20.1346C22.3155 20.2512 22.4261 20.5641 22.2952 20.8195L21.6594 22.0604C21.5335 22.3062 21.6306 22.6075 21.8764 22.7334V22.7334C22.1221 22.8593 22.4235 22.7622 22.5494 22.5164L23.2356 21.1771C23.3567 20.9409 23.6412 20.8404 23.8837 20.9482L25.1744 21.5218C25.4267 21.634 25.7222 21.5203 25.8344 21.268V21.268C25.9465 21.0156 25.8329 20.7201 25.5805 20.608L24.3909 20.0793C24.1287 19.9627 24.0182 19.6498 24.149 19.3944L24.9032 17.9224C25.0291 17.6767 24.932 17.3754 24.6862 17.2495V17.2495C24.4404 17.1235 24.1391 17.2207 24.0132 17.4664L23.2086 19.0369C23.0876 19.2731 22.8031 19.3736 22.5605 19.2658L21.3272 18.7176C21.0749 18.6055 20.7794 18.7191 20.6672 18.9714V18.9714C20.5551 19.2238 20.6687 19.5193 20.9211 19.6314L22.0533 20.1346Z",
    fill: "#FF3269"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 8.19522,
    y1: 13.1042,
    x2: 1.30633,
    y2: 15.4005,
    stroke: "#FF3269"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 22.9956,
    y1: 2.55011,
    x2: 28.507,
    y2: 12.7506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF794D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarsIcon);
export default __webpack_public_path__ + "static/media/stars-icon.40431e53e40f3ef5a4b2b2b1dd812084.svg";
export { ForwardRef as ReactComponent };